/**
 * Copyright © 2026 Adnuntius AS.
 */
export function contentPage(component: any) {
  return {
    component
  };
}
